var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "close_svg__circle",
    d: "M24 1C17.65883 1 11.90907 3.57983 7.74445 7.74445 3.57983 11.90907 1 17.65883 1 24s2.57983 12.09093 6.74445 16.25555C11.90907 44.42017 17.65883 47 24 47s12.09093-2.57983 16.25555-6.74445C44.42017 36.09093 47 30.34117 47 24s-2.57983-12.09093-6.74445-16.25555C36.09093 3.57983 30.34117 1 24 1z",
    stroke: "transparent",
    strokeWidth: 2,
    fillOpacity: 0.5,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "close_svg__x",
    d: "M32.96168 15.87553c.43594.43593.43594 1.14272 0 1.57865l-7.10417 7.1034 7.10417 7.10452c.43594.43593.43594 1.14272 0 1.57865-.43593.43594-1.14272.43594-1.57865 0l-7.10452-7.10417-7.1034 7.10417c-.43593.43594-1.14272.43594-1.57865 0-.43594-.43593-.43594-1.14272 0-1.57865l7.10305-7.10452-7.10305-7.1034c-.43594-.43593-.43594-1.14272 0-1.57865.43593-.43594 1.14272-.43594 1.57865 0l7.1034 7.10305 7.10452-7.10305c.43593-.43594 1.14272-.43594 1.57865 0z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}

export default __webpack_public_path__ + "ondemand/static/8b50f6e88/icons/close.svg";
export { SvgClose as ReactComponent };